import type { ICopyIcon } from './helpers';

export const CopyIcon = ({ variant = 'light', ...rest }: ICopyIcon) => {
	if (variant === 'light')
		return (
			<svg
				width='16'
				height='17'
				viewBox='0 0 16 17'
				fill='none'
				xmlns='http://www.w3.org/2000/svg'
				data-testid='copy-icon'
				{...rest}
			>
				<path
					d='M4.66653 4.91374V2.91374C4.66653 2.54555 4.96501 2.24707 5.3332 2.24707H13.3332C13.7014 2.24707 13.9999 2.54555 13.9999 2.91374V12.2471C13.9999 12.6153 13.7014 12.9137 13.3332 12.9137H11.3332V14.9131C11.3332 15.2817 11.0333 15.5804 10.662 15.5804H2.67111C2.30039 15.5804 2 15.284 2 14.9131L2.00173 5.58098C2.0018 5.21248 2.30176 4.91374 2.67295 4.91374H4.66653ZM3.33495 6.24707L3.33346 14.2471H9.99987V6.24707H3.33495ZM5.99987 4.91374H11.3332V11.5804H12.6665V3.5804H5.99987V4.91374Z'
					fill='#022745'
				/>
			</svg>
		);

	if (variant === 'colored')
		return (
			<svg
				width='16'
				height='16'
				viewBox='0 0 16 16'
				fill='none'
				xmlns='http://www.w3.org/2000/svg'
				data-testid='copy-icon'
				{...rest}
			>
				<path
					d='M10.6668 8.60016V11.4002C10.6668 13.7335 9.7335 14.6668 7.40016 14.6668H4.60016C2.26683 14.6668 1.3335 13.7335 1.3335 11.4002V8.60016C1.3335 6.26683 2.26683 5.3335 4.60016 5.3335H7.40016C9.7335 5.3335 10.6668 6.26683 10.6668 8.60016Z'
					fill='#05A2BF'
				/>
				<path
					opacity='0.4'
					d='M11.3998 1.3335H8.59984C6.29984 1.3335 5.36651 2.24683 5.33984 4.50016H7.39984C10.1998 4.50016 11.4998 5.80016 11.4998 8.60016V10.6602C13.7532 10.6335 14.6665 9.70016 14.6665 7.40016V4.60016C14.6665 2.26683 13.7332 1.3335 11.3998 1.3335Z'
					fill='#05A2BF'
				/>
			</svg>
		);

	if (variant === 'asset')
		return (
			<svg
				width='48'
				height='48'
				viewBox='0 0 48 48'
				fill='none'
				xmlns='http://www.w3.org/2000/svg'
				data-testid='copy-icon'
				{...rest}
			>
				<rect
					width='48'
					height='48'
					rx='24'
					fill='#CCF9FB'
				/>
				<path
					d='M26.6666 24.6026V27.4026C26.6666 29.7359 25.7333 30.6693 23.3999 30.6693H20.5999C18.2666 30.6693 17.3333 29.7359 17.3333 27.4026V24.6026C17.3333 22.2693 18.2666 21.3359 20.5999 21.3359H23.3999C25.7333 21.3359 26.6666 22.2693 26.6666 24.6026Z'
					fill='#022745'
				/>
				<path
					opacity='0.4'
					d='M27.4001 17.3359H24.6001C22.3001 17.3359 21.3668 18.2493 21.3401 20.5026H23.4001C26.2001 20.5026 27.5001 21.8026 27.5001 24.6026V26.6626C29.7534 26.6359 30.6668 25.7026 30.6668 23.4026V20.6026C30.6668 18.2693 29.7334 17.3359 27.4001 17.3359Z'
					fill='#022745'
				/>
			</svg>
		);

	if (variant === 'negative')
		return (
			<svg
				width='16'
				height='16'
				viewBox='0 0 16 16'
				fill='none'
				xmlns='http://www.w3.org/2000/svg'
				data-testid='copy-icon'
				{...rest}
			>
				<path
					d='M10.6666 8.59992V11.3999C10.6666 13.7333 9.73325 14.6666 7.39992 14.6666H4.59992C2.26659 14.6666 1.33325 13.7333 1.33325 11.3999V8.59992C1.33325 6.26658 2.26659 5.33325 4.59992 5.33325H7.39992C9.73325 5.33325 10.6666 6.26658 10.6666 8.59992Z'
					fill='#022745'
				/>
				<path
					opacity='0.4'
					d='M11.3998 1.33325H8.59984C6.29984 1.33325 5.36651 2.24659 5.33984 4.49992H7.39984C10.1998 4.49992 11.4998 5.79992 11.4998 8.59992V10.6599C13.7532 10.6333 14.6665 9.69992 14.6665 7.39992V4.59992C14.6665 2.26659 13.7332 1.33325 11.3998 1.33325Z'
					fill='#022745'
				/>
			</svg>
		);

	return (
		<svg
			width='17'
			height='17'
			viewBox='0 0 17 17'
			fill='none'
			xmlns='http://www.w3.org/2000/svg'
			data-testid='copy-icon'
			{...rest}
		>
			<path
				d='M11.1668 8.85395V11.6539C11.1668 13.9873 10.2335 14.9206 7.90016 14.9206H5.10016C2.76683 14.9206 1.8335 13.9873 1.8335 11.6539V8.85395C1.8335 6.52061 2.76683 5.58728 5.10016 5.58728H7.90016C10.2335 5.58728 11.1668 6.52061 11.1668 8.85395Z'
				fill='#748181'
			/>
			<path
				opacity='0.4'
				d='M11.8998 1.58728H9.09984C6.79984 1.58728 5.86651 2.50061 5.83984 4.75395H7.89984C10.6998 4.75395 11.9998 6.05395 11.9998 8.85395V10.9139C14.2532 10.8873 15.1665 9.95395 15.1665 7.65395V4.85395C15.1665 2.52061 14.2332 1.58728 11.8998 1.58728Z'
				fill='#748181'
			/>
		</svg>
	);
};
